import { BulkMessage, BulkMessageStatistics, BulkSMSReportQuery } from "../../../hooks/apis/bulkmessages.api";
import Loader from "../../generic/Loader";
import Table, { ColumnsType } from "antd/es/table";
import { Flex, Popover } from "antd";
import phoneImg from "../../../assets/images/icon/Phone-call.svg";
import dayjs from "dayjs";
import { formatPhoneNumber } from "../../../utils/phoneLib";
import { pageChange } from "../../../utils/PageChange";
import { useNavigate } from "react-router-dom";
import BulkMessageStatusTable from "../../Tables/BulkMesagesStatus";

const bodyStyle: React.CSSProperties = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "#8c8c8c",
    width: "160px",
    display: "block"
};

const BulkMessagesTable: React.FC<{
    filters: BulkSMSReportQuery;
    statistics: BulkMessageStatistics | null;
    messages: BulkMessage[];
    page: number;
    isLoading: boolean;
    setFilters: Function;
}> = ({ filters, statistics, messages, page, isLoading, setFilters }) => {
    const navigate = useNavigate();


    if (!filters) {
        return <Loader />;
    }


    const columns: ColumnsType<BulkMessage> = [
        {
            title: "NUMBER",
            dataIndex: "did",
            key: "did",
            render: (_, record) => {
                return (
                    <Flex align="center" gap={10}>
                        <img src={phoneImg} alt="" className="avatar-sm" />
                        <span className="text-xs font-weight-bold">{formatPhoneNumber(record.did)}</span>
                    </Flex>
                );
            }
        },
        {
            title: "USER",
            dataIndex: "user_id",
            key: "user_id",
            render: (_, record) => {
                return (
                    <>
                        {" "}
                        <span className="text-xs font-weight-bold">{record.first_name + " " + record.last_name}</span>
                    </>
                );
            }
        },
        {
            title: "LABEL",
            dataIndex: "label",
            key: "label",
            render: (_, record) => {
                return (
                    <Popover content={record.label}>
                        <span style={bodyStyle} className="text-xs font-weight-bold">
                            {record.label}
                        </span>
                    </Popover>
                );
            }
        },
        {
            title: "PENDING",
            dataIndex: "pending",
            key: "pending",
            render: (_, record) => {
                return <span className="text-xs font-weight-bold">{record.pending}</span>;
            },
            width: 80
        },
        {
            title: "SENT",
            dataIndex: "sent",
            key: "sent",
            render: (_, record) => {
                return <span className="text-xs font-weight-bold">{record.sent}</span>;
            },
            width: 80
        },
        {
            title: "SCHEDULED",
            dataIndex: "scheduled",
            key: "scheduled",
            render: (_, record) => {
                return <span className="text-xs font-weight-bold">{record.scheduled}</span>;
            },
            width: 100
        },
        {
            title: "FAILED",
            dataIndex: "failed",
            key: "failed",
            render: (_, record) => {
                return <span className="text-xs font-weight-bold">{record.failed}</span>;
            },
            width: 80
        },

        {
            title: "DATE AND TIME",
            dataIndex: "created_at",
            key: "created_at",
            render: (_, record) => {
                return <span className="text-xs font-weight-bold">{dayjs(record.created_at).format("MM/DD/YYYY hh:mm A")}</span>;
            },
            width: 150
        }
    ];

    return (
        <div>
            <Table
                className="messages-report-table"
                columns={columns}
                dataSource={messages}
                loading={isLoading}
                scroll={{ y: 400 }}
                key={"id"}
                rowKey={"id"}
                expandable={{
                    expandedRowRender: record => {
                        return <BulkMessageStatusTable id={record.id} search={""} />;
                    },
                    showExpandColumn: true
                }}
                pagination={{
                    onChange: page => {
                        pageChange(page, navigate);
                    },
                    current: Number(page),
                    pageSize: filters.limit,
                    total: statistics?.total_bulk_jobs || 0,
                    showSizeChanger: false,
                    onShowSizeChange: (_, pageSize) => {
                        setFilters({ ...filters, limit: pageSize });
                    },
                    position: ["none", "bottomCenter"]
                }}
            />
        </div>
    );
};

export default BulkMessagesTable;
